import * as React from 'react';

import { useMessageHtmlText } from '../../../hooks/useMessageHtmlText';
import { useMessageText } from '../../../hooks/useMessageText';
import { useMessageContext } from '../../../../../utils/messageContext';

export const useTextMessageContent = (): React.ReactNode => {
  const { message, messageId, messageType, chatId } = useMessageContext();

  const htmlText = useMessageHtmlText(message);
  const text = useMessageText({ message, messageId, messageType, chatId });

  if (htmlText) {
    // oxlint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: htmlText }} />;
  }

  if (text) {
    return text;
  }

  return null;
};
